document.addEventListener("DOMContentLoaded", function() {
  // TLD khusus
  const tldMap = {
    "Indonesia": ".co.id",
    "Singapore": ".com.sg",
    "Malaysia": ".com.my",
    "Hong Kong": ".com.hk",
    "Philippines": ".com.ph",
    "India": ".co.in",
    "Germany": ".de",
    "China": ".cn"
  };

  // Data negara dunia (ISO 3166, nama lengkap, kode, flag SVG)
  const countries = [
    { name: "Indonesia", code: "ID" },
    { name: "Malaysia", code: "MY" },
    { name: "Philippines", code: "PH" },
    { name: "United States", code: "US" },
    { name: "China", code: "CN" },
    { name: "Argentina", code: "AR" },
    { name: "Armenia", code: "AM" },
    { name: "Australia", code: "AU" },
    { name: "Austria", code: "AT" },
    { name: "Azerbaijan", code: "AZ" },
    { name: "Bahrain", code: "BH" },
    { name: "Bangladesh", code: "BD" },
    { name: "Barbados", code: "BB" },
    { name: "Belarus", code: "BY" },
    { name: "Belgium", code: "BE" },
    { name: "Bolivia", code: "BO" },
    { name: "Bosnia and Herzegovina", code: "BA" },
    { name: "Brazil", code: "BR" },
    { name: "Brunei", code: "BN" },
    { name: "Bulgaria", code: "BG" },
    { name: "Cambodia", code: "KH" },
    { name: "Canada", code: "CA" },
    { name: "Central African Republic", code: "CF" },
    { name: "Chile", code: "CL" },
    { name: "Colombia", code: "CO" },
    { name: "Costa Rica", code: "CR" },
    { name: "Croatia", code: "HR" },
    { name: "Cyprus", code: "CY" },
    { name: "Denmark", code: "DK" },
    { name: "Dominican Republic", code: "DO" },
    { name: "Ecuador", code: "EC" },
    { name: "Egypt", code: "EG" },
    { name: "El Salvador", code: "SV" },
    { name: "Estonia", code: "EE" },
    { name: "Fiji", code: "FJ" },
    { name: "Finland", code: "FI" },
    { name: "France", code: "FR" },
    { name: "Georgia", code: "GE" },
    { name: "Germany", code: "DE" },
    { name: "Ghana", code: "GH" },
    { name: "Greece", code: "GR" },
    { name: "Guatemala", code: "GT" },
    { name: "Honduras", code: "HN" },
    { name: "Hong kong", code: "HK" },
    { name: "Hungary", code: "HU" },
    { name: "Iceland", code: "IS" },
    { name: "India", code: "IN" },
    { name: "Ireland", code: "IE" },
    { name: "Israel", code: "IL" },
    { name: "Italy", code: "IT" },
    { name: "Jamaica", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "Jordan", code: "JO" },
    { name: "Kazakhstan", code: "KZ" },
    { name: "Kenya", code: "KE" },
    { name: "Kuwait", code: "KW" },
    { name: "Laos", code: "LA" },
    { name: "Latvia", code: "LV" },
    { name: "Lebanon", code: "LB" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Lithuania", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Maldives", code: "MV" },
    { name: "Malta", code: "MT" },
    { name: "Mauritius", code: "MU" },
    { name: "Mexico", code: "MX" },
    { name: "Moldova", code: "MD" },
    { name: "Monaco", code: "MC" },
    { name: "Mongolia", code: "MN" },
    { name: "Morocco", code: "MA" },
    { name: "Myanmar", code: "MM" },
    { name: "Namibia", code: "NA" },
    { name: "Nepal", code: "NP" },
    { name: "Netherlands", code: "NL" },
    { name: "New Zealand", code: "NZ" },
    { name: "Norway", code: "NO" },
    { name: "Oman", code: "OM" },
    { name: "Pakistan", code: "PK" },
    { name: "Panama", code: "PA" },
    { name: "Paraguay", code: "PY" },
    { name: "Peru", code: "PE" },
    { name: "Poland", code: "PL" },
    { name: "Portugal", code: "PT" },
    { name: "Qatar", code: "QA" },
    { name: "Romania", code: "RO" },
    { name: "Russia", code: "RU" },
    { name: "Saudi Arabia", code: "SA" },
    { name: "Serbia", code: "RS" },
    { name: "Slovakia", code: "SK" },
    { name: "Slovenia", code: "SI" },
    { name: "South Africa", code: "ZA" },
    { name: "South Korea", code: "KR" },
    { name: "Spain", code: "ES" },
    { name: "Sri Lanka", code: "LK" },
    { name: "Sweden", code: "SE" },
    { name: "Switzerland", code: "CH" },
    { name: "Taiwan", code: "TW" },
    { name: "Thailand", code: "TH" },
    { name: "Trinidad and Tobago", code: "TT" },
    { name: "Turkey", code: "TR" },
    { name: "Ukraine", code: "UA" },
    { name: "United Arab Emirates", code: "AE" },
    { name: "United Kingdom", code: "GB" },
    { name: "Uruguay", code: "UY" },
    { name: "Venezuela", code: "VE" },
    { name: "Vietnam", code: "VN" }
  ];

   function getCountryUrl(country, utm = {}) {
    const countrySlug = country.name.toLowerCase().replace(/ /g, '-');

    const domainMap = {
        singapore: 'https://www.floweradvisor.com.sg',
    };

    const baseUrl = domainMap[countrySlug] || `https://www.floweradvisor.com/${countrySlug}`;

    const params = new URLSearchParams({
        utm_source: utm.source || 'internal',
        utm_medium: utm.medium || 'country-list',
        utm_campaign: utm.campaign || 'country-navigation',
    });

    return `${baseUrl}?${params.toString()}`;
}

/*
  function getCountryUrl(country) {
    // if (tldMap[country.name]) {
    //   return `https://www.floweradvisor${tldMap[country.name]}`;
    // }
    return `https://www.floweradvisor.com/${country.name.toLowerCase().replace(/ /g, '-')}`;
  }

  function getCountryUrl(country) {
  // jika country.name === "Hongkong", return link khusus
  if (country.name.toLowerCase() === "hong kong") {
    return `https://www.floweradvisor.com/hong-kong`;
  }
  // default behaviour (contoh: lowercase + ganti spasi jadi "-")
  return `https://www.floweradvisor.com/${country.name.toLowerCase().replace(/ /g, '-')}`;
}
*/
  // 5 negara terlaris
  const bestCountries = [
    { name: "Indonesia", code: "ID" },
    { name: "Malaysia", code: "MY" },
    { name: "Philippines", code: "PH" },
    { name: "United States", code: "US" },
    { name: "China", code: "CN" }
  ];
  // Sisanya mulai dari urutan ke-6
  const restCountries = countries.filter(c => !bestCountries.some(b => b.code === c.code));

  function renderCountryList(modal, search = "") {
    // Elemen judul dan list
    const bestTitle = modal.querySelector('.country-group-title-best');
    const restTitle = modal.querySelector('.country-group-title-rest');
    const searchTitle = modal.querySelector('.country-group-title-search');
    const bestList = modal.querySelector('.country-list-best');
    const restList = modal.querySelector('.country-list-rest');
    const searchList = modal.querySelector('.country-list-search');

    function getRel(country) {
      // Negara dengan TLD khusus (ada di tldMap) atau US/AU tidak diberi nofollow
      if (tldMap[country.name] || country.code === 'US' || country.code === 'AU') return ' rel="nofollow"';
      return ' rel="nofollow"';
    }
    /*
    function countryListHTML(list) {
      return list.map(country => `
        <li>
          <img src="https://flagcdn.com/${country.code.toLowerCase()}.svg" alt="${country.code}" width="28" height="20" style="border-radius: 3px;" role="presentation" aria-hidden="true" />
          <a href="${getCountryUrl(country)}" tabindex="0"${getRel(country)}>${country.name}</a>
        </li>
      `).join("");
    }
    */

    function countryListHTML(list) {
      return list
        .map(
          (country) => `
            <li>
              <img src="https://flagcdn.com/${country.code.toLowerCase()}.svg" alt="${country.code}" width="28" height="20" style="border-radius: 3px;" role="presentation" aria-hidden="true" />
              <a href="${getCountryUrl(country, { source: 'fa-sg', medium: 'dropdown', campaign: 'global-navigation' })}" tabindex="0"${getRel(country)}>${country.name}</a>
            </li>
          `
        )
        .join("");
    }

    if (search) {
      // Sembunyikan judul dan list kelompok
      if (bestTitle) bestTitle.style.display = 'none';
      if (restTitle) restTitle.style.display = 'none';
      if (bestList) bestList.style.display = 'none';
      if (restList) restList.style.display = 'none';
      // Tampilkan judul dan list search
      if (searchTitle) searchTitle.style.display = '';
      if (searchList) searchList.style.display = '';
      // Gabungkan hasil pencarian best+rest
      const s = search.toLowerCase();
      const filtered = [...bestCountries, ...restCountries].filter(c => c.name.toLowerCase().includes(s) || c.code.toLowerCase().includes(s));
      if (searchList) searchList.innerHTML = filtered.length ? countryListHTML(filtered) : '<li style="color:#888;">No country found</li>';
    } else {
      // Tampilkan judul dan list kelompok
      if (bestTitle) bestTitle.style.display = '';
      if (restTitle) restTitle.style.display = '';
      if (bestList) bestList.style.display = '';
      if (restList) restList.style.display = '';
      // Sembunyikan search
      if (searchTitle) searchTitle.style.display = 'none';
      if (searchList) searchList.style.display = 'none';
      // Render best
      if (bestList) bestList.innerHTML = countryListHTML(bestCountries);
      // Render rest
      if (restList) restList.innerHTML = countryListHTML(restCountries);
    }
  }

  // Fungsi untuk membuat wrapper popup beserta seluruh isinya
  function createCountryPopupWrapper(modalName) {
    // Buat elemen wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'country-popup-modal country-popup-overlay';
    wrapper.setAttribute('data-modal', modalName);
    wrapper.style.display = 'none';
    wrapper.innerHTML = `
      <div class="country-popup-content">
        <input type="text" class="country-search-modal country-search-input" placeholder="Search" autocomplete="off" />
        <div class="country-list-scrollable">
          <div class="country-group-title country-group-title-best">Best-selling Country</div>
          <ul class="country-list-modal country-list-best"></ul>
          <div class="country-group-title country-group-title-rest">We deliver to 100+ Countries</div>
          <ul class="country-list-modal country-list-rest"></ul>
          <div class="country-group-title country-group-title-search" style="display:none">Country by Search</div>
          <ul class="country-list-modal country-list-search" style="display:none"></ul>
        </div>
      </div>
    `;
    document.body.appendChild(wrapper);
    return wrapper;
  }

  // Track which modals have been initialized
  const initializedModals = new Set();
  const createdWrappers = {};

  // Function to initialize a modal (render content and add event listeners)
  function initializeModal(modal) {
    if (initializedModals.has(modal)) {
      return; // Already initialized
    }
    // Render the country list
    renderCountryList(modal);
    // Add search input event listener
    const searchInput = modal.querySelector(".country-search-modal");
    if (searchInput) {
      searchInput.addEventListener("input", function() {
        renderCountryList(modal, this.value);
      });
    }
    // Mark as initialized
    initializedModals.add(modal);
  }

  // Event untuk semua trigger
  document.querySelectorAll('.country-trigger-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var modalName = btn.getAttribute('data-modal');
      var modal = document.querySelector('.country-popup-modal[data-modal="' + modalName + '"]');
      // Jika wrapper belum ada, buat dulu
      if (!modal) {
        modal = createCountryPopupWrapper(modalName);
      }
      // Initialize modal if not already done
      initializeModal(modal);
      // Show the modal
      modal.style.display = "flex";
      // Focus on search input
      const searchInput = modal.querySelector(".country-search-modal");
      if (searchInput) {
        searchInput.focus();
      }
    });
  });

  // Tutup popup jika klik di luar area popup
  window.addEventListener("mousedown", function(e) {
    document.querySelectorAll(".country-popup-modal").forEach(function(modal) {
      const content = modal.querySelector(".country-popup-content");
      // Cek semua trigger
      let isTrigger = false;
      document.querySelectorAll('.country-trigger-btn').forEach(function(btn) {
        if (btn.contains(e.target)) isTrigger = true;
      });
      if (
        modal.style.display === "flex" &&
        !content.contains(e.target) &&
        !isTrigger
      ) {
        modal.style.display = "none";
      }
    });
  });
});